var _rect, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnnotationLine = function SvgAnnotationLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 15,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.5,
    height: 95.5,
    x: 108.25,
    y: 7.25,
    stroke: "url(#annotation-line_svg__a)",
    strokeWidth: 0.5,
    rx: 0.25,
    transform: "rotate(90 108.25 7.25)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#annotation-line_svg__b)",
    shapeRendering: "crispEdges"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.308,
    cy: 7.5,
    r: 2.5,
    fill: "#634F69",
    fillOpacity: 0.45
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 8.308,
    cy: 7.5,
    r: 2.5,
    fill: "url(#annotation-line_svg__c)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.308,
    cy: 7.5,
    r: 2,
    stroke: "#F5C0C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "annotation-line_svg__a",
    x1: 109.042,
    x2: 155.391,
    y1: 7,
    y2: 42.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "annotation-line_svg__c",
    x1: 8.308,
    x2: 8.308,
    y1: 4.431,
    y2: 10.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C0C0",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5C0C0",
    stopOpacity: 0.14
  })), /*#__PURE__*/React.createElement("filter", {
    id: "annotation-line_svg__b",
    width: 15,
    height: 15,
    x: 0.808,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.960784 0 0 0 0 0.752941 0 0 0 0 0.752941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_194_3936"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_194_3936",
    result: "shape"
  })))));
};
export { SvgAnnotationLine as ReactComponent };
export default "data:image/svg+xml;base64,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";